export const PROGRESS_MILESTONES_WRAPPER_TEST_ID = 'progress-milestones-wrapper'
export const PERIOD_SWITCH_WRAPPER_TEST_ID = 'period-switch-wrapper'
export const PERIOD_SWITCH_TEST_ID = 'period-switch'
export const PROGRESS_SETTINGS_WRAPPER_TEST_ID = 'progress-settings-wrapper'
export const GRANULATION_SELECT_TEST_ID = 'granulation-select'
export const PERIOD_AGGREGATION_SELECT_TEST_ID = 'period-aggregation-select'
export const MILESTONES_LIST_HEADER_TEST_ID = 'milestones-list-header'
export const MILESTONES_LIST_BODY_TEST_ID = 'milestones-list-body'
export const ADD_MILESTONE_BUTTON_TEST_ID = 'add-milestone-button'
export const MILESTONE_ITEM_TEST_ID = 'milestone-item'
export const REMOVE_MILESTONE_BUTTON_TEST_ID = 'remove-milestone-button'
export const MILESTONE_TARGET_VALUE_TEST_ID = 'milestone-target-value'
export const MILESTONE_DATE_PICKER_TEST_ID = 'milestone-date-picker'
export const TOGGLE_PROGRESS_CHART_BUTTON_TEST_ID = 'toggle-chart-button'
export const ELEMENT_PROGRESS_CHART_TEST_ID = 'progress-chart'
export const ELEMENT_PROGRESS_SETUP_BUTTON_TEST_ID = 'progress-setup-button'
export const ELEMENT_PROGRESS_SETUP_BACK_BUTTON_TEST_ID = 'back-button'
export const ELEMENT_PROGRESS_TABLE_COLUMN_COUNT_SWITCH_TEST_ID = 'table-column-count-switch'
export const ELEMENT_PROGRESS_TABLE_TEST_ID = 'element-progress-table'
export const ELEMENT_PROGRESS_HISTORY_TEST_ID = 'element-progress-history'
export const ELEMENT_PROGRESS_HISTORY_ITEM_TEST_ID = 'element-progress-history-item'
export const ELEMENT_PROGRESS_HISTORY_CONTENT_TEST_ID = 'element-progress-history-content'
export const REMOVE_PROGRESS_HISTORY_ITEM_BUTTON_TEST_ID = 'remove-history-item-button'
